<div class="prepaid-redemption">
  @if (loading) {
    <div class="prepaid-redemption__loading" aria-busy="true">
      @for (s of [0, 1, 2]; track s) {
        <span class="prepaid-redemption__shimmer"></span>
      }
    </div>
  } @else if (error) {
    <div class="prepaid-redemption__error" role="alert">
      <p>{{ error }}</p>
      <button type="button" class="prepaid-redemption__retry" (click)="onRetry()">Try again</button>
    </div>
  } @else if (status) {
    <div class="prepaid-redemption__panel">
      <div class="prepaid-redemption__header">
        <span class="prepaid-redemption__header-label">Prepaid Washbook</span>
        <span class="prepaid-redemption__header-title" [attr.title]="bookName">{{ bookName }}</span>
      </div>

      @if (summaryCards.length > 0) {
        <div class="prepaid-redemption__summary-cards">
          @for (card of summaryCards; track card.purchaseItemId) {
            <div class="prepaid-redemption__summary-card">
              <span class="prepaid-redemption__summary-wash-type">{{ card.washTypeLabel }}</span>
              <span class="prepaid-redemption__summary-remaining"
                >{{ card.remaining }}/{{ card.limit }} remaining</span
              >
              <span class="prepaid-redemption__summary-name">{{ card.packageLabel }}</span>
              @if (card.dateLine) {
                <span class="prepaid-redemption__summary-dates">
                  <img
                    src="assets/images/payment-summary/calendar.svg"
                    alt=""
                    class="prepaid-redemption__summary-calendar-icon"
                  />
                  <span>{{ card.dateLine }}</span>
                </span>
              }
            </div>
          }
        </div>
      }

      <div class="prepaid-redemption__select-section">
        <span class="prepaid-redemption__select-title">
          Select Wash to Redeem
          @if (selectedCount > 0) {
            <span class="prepaid-redemption__select-count">({{ selectedCount }} selected)</span>
          }
        </span>
        <div class="prepaid-redemption__tabs" role="tablist">
          <button
            type="button"
            class="prepaid-redemption__tab"
            role="tab"
            [class.prepaid-redemption__tab--active]="activeTab === 'active'"
            [attr.aria-selected]="activeTab === 'active'"
            (click)="setRedemptionTab('active')"
          >
            Active Wash
          </button>
          <button
            type="button"
            class="prepaid-redemption__tab"
            role="tab"
            [class.prepaid-redemption__tab--active]="activeTab === 'redeemed'"
            [attr.aria-selected]="activeTab === 'redeemed'"
            (click)="setRedemptionTab('redeemed')"
          >
            Redeemed Wash
          </button>
        </div>

        @if (showRedeemedListError) {
          <div class="prepaid-redemption__list-error" role="alert">
            <p>{{ redemptionsError }}</p>
            <button type="button" class="prepaid-redemption__retry" (click)="onRetryRedemptions()">
              Try again
            </button>
          </div>
        } @else if (showRedeemedListLoading) {
          <div class="prepaid-redemption__list-loading" aria-busy="true">
            @for (s of [0, 1]; track s) {
              <span class="prepaid-redemption__shimmer"></span>
            }
          </div>
        } @else {
          <ul class="prepaid-redemption__slot-list" role="list">
            @for (slot of visibleSlots; track slot.slotKey) {
              <li
                class="prepaid-redemption__slot"
                [class.prepaid-redemption__slot--redeemed]="slot.tab === 'redeemed'"
              >
                @if (slot.tab === 'active') {
                  <label class="prepaid-redemption__slot-label">
                    <input
                      type="radio"
                      class="prepaid-redemption__slot-check"
                      [name]="slotRadioGroupName"
                      [checked]="isSlotSelected(slot.slotKey)"
                      (change)="onSlotToggle(slot)"
                    />
                    <span class="prepaid-redemption__slot-text">
                      <span class="prepaid-redemption__slot-title">{{ slot.label }}</span>
                      <span class="prepaid-redemption__slot-sub">{{ formatSlotSubline(slot) }}</span>
                    </span>
                  </label>
                  @if (showRecipientForSlot(slot.slotKey)) {
                    <div class="prepaid-redemption__recipient">
                      <div class="prepaid-redemption__recipient-grid">
                        <div class="prepaid-redemption__recipient-field prepaid-redemption__recipient-field--full">
                          <label
                            class="prepaid-redemption__recipient-label"
                            [attr.for]="'redeem-plate-' + slot.slotKey.replace('#', '-')"
                          >
                            License Plate <span class="prepaid-redemption__required">*</span>
                          </label>
                          <input
                            type="text"
                            class="prepaid-redemption__recipient-input"
                            [id]="'redeem-plate-' + slot.slotKey.replace('#', '-')"
                            [value]="recipient.licensePlate"
                            (input)="onRecipientPlateInput($event)"
                            [class.prepaid-redemption__recipient-input--error]="!!plateError"
                            placeholder="Enter number plate"
                            autocomplete="off"
                            [attr.aria-invalid]="!!plateError"
                          />
                          @if (plateError) {
                            <div class="prepaid-redemption__field-error" role="alert">
                              {{ plateError }}
                            </div>
                          }
                        </div>
                        <div class="prepaid-redemption__recipient-field">
                          <label
                            class="prepaid-redemption__recipient-label"
                            [attr.for]="'redeem-phone-' + slot.slotKey.replace('#', '-')"
                          >
                            Phone Number
                          </label>
                          <div class="prepaid-redemption__phone-input-container">
                            <input
                              type="tel"
                              inputmode="tel"
                              class="prepaid-redemption__recipient-input"
                              [class.prepaid-redemption__recipient-input--error]="hasFieldError('phone')"
                              [id]="'redeem-phone-' + slot.slotKey.replace('#', '-')"
                              [value]="recipient.phone"
                              (input)="onRecipientPhoneInput($event)"
                              (blur)="onRecipientPhoneBlur()"
                              [attr.maxlength]="phoneMaxLength"
                              placeholder="Enter phone number"
                              autocomplete="tel"
                              [attr.aria-invalid]="hasFieldError('phone')"
                            />
                            @if (showPhoneDropdown && phoneSearchResults.length > 0) {
                              <div
                                class="prepaid-redemption__phone-dropdown"
                                (mousedown)="$event.preventDefault()"
                              >
                                @for (customer of phoneSearchResults; track customer['customer_id'] || customer['id']) {
                                  <button
                                    type="button"
                                    class="prepaid-redemption__phone-dropdown-item"
                                    (click)="onRecipientPhoneSearchSelect(customer)"
                                  >
                                    <span class="prepaid-redemption__phone-dropdown-name">{{
                                      recipientPhoneSearchLabel(customer)
                                    }}</span>
                                    @if (customer['contact']) {
                                      <span class="prepaid-redemption__phone-dropdown-contact">{{
                                        customer['contact']
                                      }}</span>
                                    }
                                    @if (customer['email']) {
                                      <span class="prepaid-redemption__phone-dropdown-email">{{
                                        customer['email']
                                      }}</span>
                                    }
                                  </button>
                                }
                              </div>
                            }
                            @if (isSearchingPhone) {
                              <div class="prepaid-redemption__phone-search-loading" aria-busy="true">
                                Searching...
                              </div>
                            }
                          </div>
                          @if (getFieldError('phone')) {
                            <div class="prepaid-redemption__field-error" role="alert">
                              {{ getFieldError('phone') }}
                            </div>
                          }
                        </div>
                        <div class="prepaid-redemption__recipient-field">
                          <label
                            class="prepaid-redemption__recipient-label"
                            [attr.for]="'redeem-first-' + slot.slotKey.replace('#', '-')"
                          >
                            First Name
                          </label>
                          <input
                            type="text"
                            class="prepaid-redemption__recipient-input"
                            [class.prepaid-redemption__recipient-input--error]="hasFieldError('firstName')"
                            [id]="'redeem-first-' + slot.slotKey.replace('#', '-')"
                            [value]="recipient.firstName"
                            (input)="onRecipientFirstNameInput($event)"
                            (blur)="onRecipientFieldBlur('firstName')"
                            [attr.maxlength]="nameMaxLength"
                            placeholder="Enter first name"
                            autocomplete="given-name"
                            [attr.aria-invalid]="hasFieldError('firstName')"
                          />
                          @if (getFieldError('firstName')) {
                            <div class="prepaid-redemption__field-error" role="alert">
                              {{ getFieldError('firstName') }}
                            </div>
                          }
                        </div>
                        <div class="prepaid-redemption__recipient-field">
                          <label
                            class="prepaid-redemption__recipient-label"
                            [attr.for]="'redeem-last-' + slot.slotKey.replace('#', '-')"
                          >
                            Last Name
                          </label>
                          <input
                            type="text"
                            class="prepaid-redemption__recipient-input"
                            [class.prepaid-redemption__recipient-input--error]="hasFieldError('lastName')"
                            [id]="'redeem-last-' + slot.slotKey.replace('#', '-')"
                            [value]="recipient.lastName"
                            (input)="onRecipientLastNameInput($event)"
                            (blur)="onRecipientFieldBlur('lastName')"
                            [attr.maxlength]="nameMaxLength"
                            placeholder="Enter last name"
                            autocomplete="family-name"
                            [attr.aria-invalid]="hasFieldError('lastName')"
                          />
                          @if (getFieldError('lastName')) {
                            <div class="prepaid-redemption__field-error" role="alert">
                              {{ getFieldError('lastName') }}
                            </div>
                          }
                        </div>
                        <div class="prepaid-redemption__recipient-field prepaid-redemption__recipient-field--full">
                          <label
                            class="prepaid-redemption__recipient-label"
                            [attr.for]="'redeem-email-' + slot.slotKey.replace('#', '-')"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            class="prepaid-redemption__recipient-input"
                            [class.prepaid-redemption__recipient-input--error]="hasFieldError('email')"
                            [id]="'redeem-email-' + slot.slotKey.replace('#', '-')"
                            [value]="recipient.email"
                            (input)="onRecipientEmailInput($event)"
                            (blur)="onRecipientFieldBlur('email')"
                            [attr.maxlength]="emailMaxLength"
                            placeholder="Enter email address"
                            autocomplete="email"
                            [attr.aria-invalid]="hasFieldError('email')"
                          />
                          @if (getFieldError('email')) {
                            <div class="prepaid-redemption__field-error" role="alert">
                              {{ getFieldError('email') }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                } @else {
                  <label class="prepaid-redemption__slot-label prepaid-redemption__slot-label--disabled">
                    <input
                      type="radio"
                      class="prepaid-redemption__slot-check prepaid-redemption__slot-check--disabled"
                      disabled
                    />
                    <span class="prepaid-redemption__slot-text">
                      <span class="prepaid-redemption__slot-title">{{ slot.label }}</span>
                      <span class="prepaid-redemption__slot-sub">{{ formatSlotSubline(slot) }}</span>
                    </span>
                  </label>
                }
              </li>
            }
            @if (visibleSlots.length === 0) {
              <li
                class="prepaid-redemption__slot-empty"
                [class.prepaid-redemption__slot-empty--fully-redeemed]="showFullyRedeemedMessage"
              >
                @if (activeTab === 'active') {
                  @if (showFullyRedeemedMessage) {
                    Prepaid package has been fully redeemed.
                  } @else {
                    No active washes available to redeem.
                  }
                } @else {
                  No redeemed washes yet.
                }
              </li>
            }
          </ul>
        }
      </div>
    </div>
  }
</div>
